import React from 'react';
import RichDataTable from "@liveramp/motif/core/RichDataTable";
import { columns, rows } from "../../demos/data";

export default function RowCursorPointer() {
  return <RichDataTable rows={rows} columns={columns} showPointerOnRows />
}
